<template>
  <div class="cashflow-type-card">
    <card :has-footer-padding="false" class="card-wrapper" :class="{'out-of-date': outOfDate,  'showing-edit-menu': showSectionMenu }">
      <template v-slot:default>
        <cashflow-type-details  :editable-category="editableCategory"
                                :show-expense-progress="!!subTree"
                                :card-title="cardTitle"
                                :sub-tree="subTree"
                                :is-income="isIncome"
                                :cashflow-category="cashflowCategory"
                                :previous-month="previousMonth"
                                :recommended-label="recommendedLabel"
                                :blocked="blocked"
                                :out-of-date="outOfDate"
                                :show-warning-if-exceeding-budget="showWarningIfExceedingBudget"
                                v-on:section-menu-opened="sectionMenuOpened"
                                v-on:section-menu-closed="sectionMenuClosed"/>
      </template>
      <template v-slot:footer v-if="!blocked">
        <slot name="bottom" v-if="hasBottomSlot"></slot>
      </template>
    </card>
    <tracking-category-section-menu v-if="showSectionMenu"
                                    :category="editableCategory"
                                    :category-name="subTree.categoryName"
                                    :envelope-id="subTree.envelopeId"
                                    :up-to-now-amount="subTree.upToNowAmount"
                                    :closeMenu="closeMenu"/>
  </div>
</template>

<script>
import _ from 'lodash';
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import TrackingCategorySectionMenu from '../../../current-month/components/cashflow-edit/edit-reccuring/TrackingCategorySectionMenu.vue';
import CashflowTypeDetails from './CashflowTypeDetails';

export default {
  name: 'CashflowTypeCard',
  components: {
    Card: BaseUI.Card,
    TrackingCategorySectionMenu,
    CashflowTypeDetails,
  },
  data() {
    return {
      showSectionMenu: false,
    };
  },
  props: {
    canEditCategory: {
      type: Boolean,
      default: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    subTree: {
      type: Object,
      required: false,
    },
    isIncome: {
      type: Boolean,
      default: false,
    },
    cashflowCategory: {
      type: String,
      required: false,
    },
    previousMonth: {
      type: Boolean,
      default: false,
    },
    recommendedLabel: {
      type: String,
      required: false,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
    pathToCategories: {
      type: String,
      default: 'categories',
    },
    showWarningIfExceedingBudget: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    editableCategory() {
      return this.isEditableCategory ? this.subCategories[0] : null;
    },
    hasBottomSlot() {
      return !!this.$slots.bottom;
    },
    isEditableCategory() {
      return !this.outOfDate && !this.previousMonth && !this.blocked && this.canEditCategory;
    },
    subCategories() {
      return this.subTree ? _.get(this.subTree, this.pathToCategories) : [];
    },
  },
  methods: {
    sectionMenuClosed() {
      this.showSectionMenu = false;
    },
    sectionMenuOpened() {
      Segment.trackUserInteraction('OpenSectionMenuClicked', {
        trackingCategory: this.subTree.categoryName,
      });
      this.showSectionMenu = true;
    },
    closeMenu() {
      this.showSectionMenu = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '~base-ui/src/scss/riseup-vars';
@import '../../../../../../../../../scss/mixins';

.cashflow-type-card {
  position: relative;

  .card-wrapper {
    padding-top: 18px;
    &.showing-edit-menu {
      opacity: 0.5;
    }

    &.out-of-date {
      color: $riseup_gray_2;
    }
  }
}

</style>
